var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "d-flex align-items-center justify-content-between",
      style: { gap: "20px" }
    },
    [
      _c(
        "div",
        { staticClass: "d-flex align-items-center", style: { gap: "12px" } },
        [
          _c(
            "div",
            {
              staticClass: "d-flex align-items-center",
              style: { gap: "12px" }
            },
            [
              _c("el-input", {
                style: { width: "375px" },
                attrs: {
                  size: "small",
                  placeholder: "Código ou nome",
                  "prefix-icon": "el-icon-search",
                  clearable: ""
                },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    return _vm.setFilters()
                  }
                },
                model: {
                  value: _vm.filters.search,
                  callback: function($$v) {
                    _vm.$set(_vm.filters, "search", $$v)
                  },
                  expression: "filters.search"
                }
              }),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary", circle: "" },
                  on: {
                    click: function($event) {
                      return _vm.setFilters()
                    }
                  }
                },
                [_c("i", { staticClass: "el-icon-search" })]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "FilterBuilder",
            { on: { apply: _vm.setFilters } },
            [
              _c(
                "template",
                { slot: "list" },
                [
                  _c("FilterBuilderDateRange", {
                    attrs: { title: "Período", icon: "el-icon-date" },
                    model: {
                      value: _vm.filters.periodo,
                      callback: function($$v) {
                        _vm.$set(_vm.filters, "periodo", $$v)
                      },
                      expression: "filters.periodo"
                    }
                  }),
                  _vm._v(" "),
                  _c("FilterBuilderSelect", {
                    attrs: {
                      title: "Situação",
                      icon: "el-icon-circle-check",
                      options: _vm.status
                    },
                    model: {
                      value: _vm.filters.status,
                      callback: function($$v) {
                        _vm.$set(_vm.filters, "status", $$v)
                      },
                      expression: "filters.status"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "FilterBuilderSelect",
                    {
                      attrs: { title: "Classes", icon: "el-icon-files" },
                      model: {
                        value: _vm.filters.classe,
                        callback: function($$v) {
                          _vm.$set(_vm.filters, "classe", $$v)
                        },
                        expression: "filters.classe"
                      }
                    },
                    _vm._l(_vm.classes, function(classe) {
                      return _c("el-option", {
                        key: classe.value,
                        attrs: { label: classe.text, value: classe.value }
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "FilterBuilderSelect",
                    {
                      attrs: { title: "UFs", icon: "el-icon-location-outline" },
                      on: { change: _vm.onUfChange },
                      model: {
                        value: _vm.filters.estado,
                        callback: function($$v) {
                          _vm.$set(_vm.filters, "estado", $$v)
                        },
                        expression: "filters.estado"
                      }
                    },
                    _vm._l(_vm.ufs, function(uf) {
                      return _c("el-option", {
                        key: uf.uf,
                        attrs: { label: uf.nome, value: uf.uf }
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "FilterBuilderSelect",
                    {
                      ref: "cidadeFilter",
                      attrs: {
                        title: "Cidade",
                        icon: "el-icon-location-outline",
                        disabled: !_vm.ufSelecionada,
                        tooltip: "",
                        "tooltip-text":
                          "Selecione uma UF para habilitar a escolha da cidade."
                      },
                      model: {
                        value: _vm.filters.cidade,
                        callback: function($$v) {
                          _vm.$set(_vm.filters, "cidade", $$v)
                        },
                        expression: "filters.cidade"
                      }
                    },
                    _vm._l(_vm.cities, function(city) {
                      return _c("el-option", {
                        key: city.id,
                        attrs: { label: city.nome, value: city.id }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            2
          ),
          _vm._v(" "),
          _c("ExcelExport", {
            attrs: {
              request: _vm.exportRequest,
              "file-name": "distribuidores",
              placement: "bottom-start"
            },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function() {
                  return [
                    _c("ExcelHeaderColumn", {
                      attrs: { title: "Código", value: "codigo" }
                    }),
                    _vm._v(" "),
                    _c("ExcelHeaderColumn", {
                      attrs: { title: "Nome", value: "nome" }
                    }),
                    _vm._v(" "),
                    _c("ExcelHeaderColumn", {
                      attrs: { title: "Classe", value: "classe" }
                    }),
                    _vm._v(" "),
                    _c("ExcelHeaderColumn", {
                      attrs: { title: "Status", value: "status" }
                    }),
                    _vm._v(" "),
                    _c("ExcelHeaderColumn", {
                      attrs: { title: "Cidade", value: "cidade" }
                    }),
                    _vm._v(" "),
                    _c("ExcelHeaderColumn", {
                      attrs: { title: "Estado", value: "uf" }
                    }),
                    _vm._v(" "),
                    _c("ExcelHeaderColumn", {
                      attrs: {
                        title: "Criado em",
                        value: "created_at",
                        callback: function(v) {
                          return v ? _vm.formatDate(v) : "Não informado"
                        }
                      }
                    })
                  ]
                },
                proxy: true
              },
              {
                key: "filters",
                fn: function(ref) {
                  var filters = ref.filters
                  return [
                    _c("FilterBuilder", {
                      attrs: { inline: "", "auto-apply": "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "list",
                            fn: function() {
                              return [
                                _c("FilterBuilderSelect", {
                                  attrs: {
                                    title: "Situação",
                                    icon: "el-icon-circle-check",
                                    options: _vm.status
                                  },
                                  model: {
                                    value: filters.status,
                                    callback: function($$v) {
                                      _vm.$set(filters, "status", $$v)
                                    },
                                    expression: "filters.status"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "FilterBuilderSelect",
                                  {
                                    attrs: {
                                      title: "Classe",
                                      icon: "el-icon-files"
                                    },
                                    model: {
                                      value: filters.classe,
                                      callback: function($$v) {
                                        _vm.$set(filters, "classe", $$v)
                                      },
                                      expression: "filters.classe"
                                    }
                                  },
                                  _vm._l(_vm.classes, function(classe) {
                                    return _c("el-option", {
                                      key: classe.value,
                                      attrs: {
                                        label: classe.text,
                                        value: classe.value
                                      }
                                    })
                                  }),
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "FilterBuilderSelect",
                                  {
                                    attrs: {
                                      title: "Estado",
                                      icon: "el-icon-location-outline"
                                    },
                                    on: { change: _vm.onUfChange },
                                    model: {
                                      value: filters.estado,
                                      callback: function($$v) {
                                        _vm.$set(filters, "estado", $$v)
                                      },
                                      expression: "filters.estado"
                                    }
                                  },
                                  _vm._l(_vm.ufs, function(uf) {
                                    return _c("el-option", {
                                      key: uf.uf,
                                      attrs: { label: uf.nome, value: uf.uf }
                                    })
                                  }),
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "FilterBuilderSelect",
                                  {
                                    ref: "cidadeFilter",
                                    attrs: {
                                      title: "Cidade",
                                      icon: "el-icon-location-outline",
                                      disabled: !_vm.ufSelecionada,
                                      tooltip: "",
                                      "tooltip-text":
                                        "Selecione uma UF para habilitar a escolha da cidade."
                                    },
                                    model: {
                                      value: filters.cidade,
                                      callback: function($$v) {
                                        _vm.$set(filters, "cidade", $$v)
                                      },
                                      expression: "filters.cidade"
                                    }
                                  },
                                  _vm._l(_vm.cities, function(city) {
                                    return _c("el-option", {
                                      key: city.id,
                                      attrs: {
                                        label: city.nome,
                                        value: city.id
                                      }
                                    })
                                  }),
                                  1
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    })
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex justify-content-end" },
        [
          _c(
            "el-dropdown",
            {
              attrs: { size: "mini", "split-button": "", plain: "" },
              on: { command: _vm.handleSetOrder }
            },
            [
              _c("strong", [_vm._v("Ordernar")]),
              _vm._v(
                ": " +
                  _vm._s(
                    _vm.filters.orderBy == "latest" ? "Recentes" : "Antigos"
                  ) +
                  "\n            "
              ),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  _c("el-dropdown-item", { attrs: { command: "latest" } }, [
                    _c("div", { staticClass: "d-flex align-items-center" }, [
                      _c("i", { staticClass: "el-icon-top mr-2" }),
                      _vm._v(
                        "\n                        Mais Recentes\n                    "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("el-dropdown-item", { attrs: { command: "oldest" } }, [
                    _c("div", { staticClass: "d-flex align-items-center" }, [
                      _c("i", { staticClass: "el-icon-bottom mr-2" }),
                      _vm._v(
                        "\n                        Mais Antigos\n                    "
                      )
                    ])
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b63e9626", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b63e9626","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/_internal/distribuidor/DistribuidorFilter.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-b63e9626","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/_internal/distribuidor/DistribuidorFilter.vue
// module chunks = 2